import axios from '@/plugins/axios'

export default {
    data() {
        return {
            tKey: 'dashboard.',
            loading: true,
            params: null,
            kpiData: null,
            kpiChartData: null,
            kpiChartEvo: null,
            provenancesData: null,
            destinationsData: null,
            regionsData: null,
            starsChart: {
                options: {
                    chart: {
                        id: "hesta_stars",
                    },
                    xaxis: {
                        categories: [],
                        title: {
                            text: this.$t("general.overnights"),
                        },
                        labels: {
                            formatter: function (value) {
                                return value.toLocaleString("de-CH");
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "top", // top, center, bottom
                            },
                            horizontal: true
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: -6,
                        style: {
                            fontSize: '12px',
                            colors: ['#1d1d1b']
                        },
                        formatter: function (value) {
                            return value.toLocaleString("de-CH");
                        }
                    },
                    colors: ["#f9af05", "#fdd77e"],
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    },
                },
                type: "bar",
                data: [
                    {
                        name: this.$t("dashboard.kpi.overnights.header"),
                        data: null,
                    },
                ],
            },
            competitors_table: null,
            competitors_header: [
                { key: "competitor", label: this.$t("dashboard.competitors.city") },
                { key: "overnights", label: this.$t("dashboard.kpi.overnights.header") },
                { key: "evolution", label: this.$t("dashboard.kpi.evolution_percent") },
            ]
        }
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
          if (newLocale !== oldLocale)
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            this.loading = true
            Promise.all([
                this.getPeriodOvernights(),
                this.getPeriodArrivals(),
                this.getPeriodStay(),
                this.getPeriodOccupationRate(),
                this.getPeriodMarkets(),
                this.getPeriodDestinations(),
                this.getMainRegionStarsNights(),
                this.getPeriodRegions(),
            ])
                .then((res) => {
                    this.kpiData = [
                        {
                            key: 'overnights',
                            data: res[0].data,
                        },
                        {
                            key: 'arrivals',
                            data: res[1].data,
                        },
                        {
                            key: 'stay',
                            data: res[2].data,
                        },
                        {
                            key: 'occupation',
                            data: res[3].data,
                        },
                    ],
                    this.provenancesData = res[4].data;
                    this.destinationsData = res[5].data;
                    this.regionsData = res[7].data;
                })
                .finally(() => {
                    this.loading = false
                    this.updateKpiChart()
                })
        },
        getPeriodOvernights() {
            return axios.post('hesta/periodRecap', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region ? this.params.region.map((r) => r.value) : [],
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodArrivals() {
            return axios.post('hesta/GetArrivalsRecap', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region.map((r) => r.value),
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodStay() {
            return axios.post('hesta/GetLOfStayRecap', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region.map((r) => r.value),
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodOccupationRate() {
            return axios.post('hesta/hestaOccupation', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region.map((r) => r.value),
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodMarkets() {
            return axios.post('hesta/getPeriodProvenances', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region.map((r) => r.value),
                top: 20,
                language: this.$i18n.locale,
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodDestinations() {
            return axios.post('hesta/getPeriodDestinations', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                language: this.$i18n.locale,
                ...this.$utils.getDestinationParams(),
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            })
        },
        getPeriodRegions() {
            return axios.post('hesta/GetHestaMainSwissRegions', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
                language: this.$i18n.locale,
            })
        },
        updateKpiChart(key = 'overnights', cumul = false) {
            this.kpiChartData = null
            let url
            switch (key) {
                case 'overnights':
                    url = 'periodPerMonth'
                    break
                case 'arrivals':
                    url = 'GetArrivalsPerMonth'
                    break
                case 'stay':
                    url = 'GetLOfStayPerMonth'
                    break
                case 'occupation':
                    url = 'GetOccupationPerMonth'
                    break
                default:
                    url = 'periodPerMonth'
                    break
            }
            axios.post(`hesta/${url}`, {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                regions: this.params.region.map((r) => r.value),
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            }).then((res) => {
                /*console.log(res.data);
                this.kpiChartData = res.data*/
                let evoPeriod = new Array();
                let actData = new Array();
                let prevData = new Array();
                let cumulAct = 0;
                let cumulPrev = 0;
                for (var i = 0; i < res.data[0].length; i++) {
                    let contentAct = {
                        year: res.data[0][i].year,
                        month: res.data[0][i].month,
                        sum: (cumulAct + res.data[0][i].sum)
                    };
                    let contentPrev = {
                        year: res.data[1][i].year,
                        month: res.data[1][i].month,
                        sum: (cumulPrev + res.data[1][i].sum)
                    };
                    let contentEvo = {
                        year: res.data[0][i].year,
                        month: res.data[0][i].month,
                        evo: (cumulAct + res.data[0][i].sum) / (cumulPrev + res.data[1][i].sum) - 1
                    };

                    // add contents to arrays
                    actData.push(contentAct);
                    prevData.push(contentPrev);
                    evoPeriod.push(contentEvo);

                    // compute cumul if necessary
                    if (cumul) {
                        cumulAct += res.data[0][i].sum;
                        cumulPrev += res.data[1][i].sum;
                    }
                }

                this.kpiChartEvo = evoPeriod;
                this.kpiChartData = [actData, prevData]
            })
        },
        getMainRegionStarsNights() {
            axios.post('hesta/getPeriodByStars', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                canton: this.$staticVariables.getCanton(),
                language: this.$i18n.locale,
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            }).then((res) => {
                let header = new Array();
                let starsData = new Array();

                res.data.forEach(element => {
                    header.push(element.stars);
                    starsData.push(element.overnights == -1 ? this.$t("general.data_protection") : element.overnights)
                });

                // send data to component
                this.starsChart.options.xaxis.categories = header;
                this.starsChart.data[0].data = starsData;
            });
        },
        getCompetitorsTable() {
            axios.post('hesta/GetCompetitorsTable', {
                monthMin: this.params.monthrange[0],
                monthMax: this.params.monthrange[1],
                regions: [101], // force param for Zürich city
                language: this.$i18n.locale,
                markets: this.params.markets.map((m) => m.value),
                comparisonYear: this.params.comparisonYear,
            }).then((res) => {
                let competitors = new Array();

                // read dictionnary
                for (const [key, value] of Object.entries(res.data)) {
                    let overnights = value.overnights;
                    let overnights_prev = value.overnightsPrev;
                    let overnights_evo = overnights / overnights_prev - 1;
                    var content = {
                        'competitor': key,
                        'overnights': overnights,
                        'overnigthsBef': overnights_prev,
                        'evolution': overnights_evo
                    }
                    competitors.push(content);
                }

                this.competitors_table = competitors;
            })
        }
    },
}